export const ES = {
    "navigation": {
      "recents": "Recientes",
      "dialpad": "Teclado",
      "contacts": "Contactos",
      "settings": "Configuración"
    },
    "account": "Cuenta",
    "call_preferences": "Preferencias de llamada",
    "conference": "Conferencia",
    "transfer_call": "Transferir llamada",
    "add_call": "Añadir llamada",
    "help": "Ayuda",
    "about": "Acerca de",
    "sound_and_devices": "Sonido y dispositivos",
    "logout": "Cerrar sesión",
    "search_contact": "Buscar contacto",
    "connectionstate": {
      "connecting": "Conectando...",
      "registering": "Registrando...",
      "available": "Disponible",
      "unavailable": "No disponible",
      "disconnected": "Desconectado",
      "connected": "Conectado"
    },
    "no_results": "Sin resultados",
    "unassigned": "No asignado",
    "call_now": "Llamar ahora",
    "transfer_now": "Transferir ahora",
    "confirm_transfer": "¿Desea transferir la llamada a",
    "call_status": {
      "finished": "Finalizada",
      "trying": "Intentando...",
      "incoming": "Entrante...",
      "calling": "Llamando...",
      "hold": "En espera"
    },
    "hold": "espera",
    "mute": "silencio",
    "confirm": "Confirmar",
    "transfer": "transferir",
    "merge": "fusionar",
    "add": "añadir",
    "keypad": "teclado",
    "swap": "intercambiar",
    "lead": "prospecto",
    "disable_recording": "Parar rec.",
    "enable_recording": "Iniciar rec.",
    "transfer_to": "Transferir llamada a",
    "add_to": "Añadir nueva llamada a",
    "hide": "ocultar",
    "talk_first": "Hablar primero",
    "extensions_domain": "Extensiones y dominio",
    "account_info": "Información de la cuenta",
    "change_password": "Cambiar contraseña",
    "update": "Actualizar",
    "old_pass_ph": "Introducir contraseña anterior",
    "new_pass_ph": "Proporcionar nueva contraseña",
    "confirm_pass_ph": "Confirmar nueva contraseña",
    "sound_notifications": "Notificaciones de sonido",
    "ringtone": "Tono de llamada",
    "speakers": "Altavoces",
    "output": "Salida",
    "ringing_device": "Dispositivo de timbre",
    "microphone": "Micrófono",
    "default": "Predeterminado",
    "default_device": "Dispositivo predeterminado",
    "keyboard_shortcuts": {
      "enter_pickup": "Presiona «Enter» para contestar",
      "esc_decline": "Presiona «Esc» para rechazar",
      "esc_hangup": "Presiona «Esc» para colgar",
      "title": "Atajos de teclado"
    },
    "help_items": {
      "chat": "Chatea con nosotros",
      "report": "Informar de un problema"
    },
    "email": "Correo electrónico",
    "password": "Contraseña",
    "login": "Iniciar sesión",
    "forgot_password": "¿Olvidaste tu contraseña?",
    "cancel": "Cancelar",
    "reset_password": "Restablecer contraseña",
    "enter_name": "Introducir nombre",
    "info": "información",
    "private": "Privado",
    "int_connection_lost": "¡Conexión a Internet perdida!",
    "int_connnection_lost_desc": "Tu ordenador parece estar desconectado. Seguiremos intentando reconectar.",
    "no_contacts": "Aún no tienes contactos.",
    "mic_requirted": "¡Se requiere acceso al micrófono!",
    "mic_requirted_desc": "Conecta el micrófono y/o concede permisos al navegador para usarlo.",
    "restart_app": "Reiniciar la aplicación",
    "password_must": "La contraseña debe contener",
    "password_recovery_strength": "al menos una letra minúscula, una mayúscula y un dígito",
    "no_recents": "No tienes llamadas recientes.",
    "no_recents_msg": "¡Haz tu primera llamada!",
    "listening": "Estás escuchando",
    "now": "ahora",
    "ws_disconnection": "Desconexión de red telefónica. Intentaremos reconectar.",
    "ws_reconnection_failed": "La aplicación no pudo reconectarse al servidor. Revisa tu conexión a Internet y reinicia la aplicación.",
    "language": "Idioma",
    "select": "Seleccionar",
    "nothing_selected": "Nada seleccionado",
    "numberValidationError": "¡Número no válido!",
    "countryNumberValidationError": "¡El número del país proporcionado no es válido!",
    "sessionExpired": "Sesión expirada",
    "auto_reject": "Rechazo automático durante llamada",
    "auto_reject_tooltip": "Rechazar llamadas entrantes automáticamente mientras estás ocupado en otra llamada",
    "general": "General",
    "field_required": "Campo obligatorio",
    "password_validation": {
      "lowercase": "La contraseña debe contener al menos una letra minúscula",
      "uppercase": "La contraseña debe contener al menos una letra mayúscula",
      "digit": "La contraseña debe contener al menos un dígito",
      "length": "La contraseña debe tener al menos 8 caracteres",
      "confirmation": "Las contraseñas no coinciden"
    },
    "email_incorrect": "La dirección de correo electrónico es incorrecta",
    "version": "Versión",
    "auto_pickup": "Contestar automáticamente (Click2Call)",
    "auto_pickup_tooltip": "Contesta automáticamente las llamadas Click2Call iniciadas por el usuario",
    "notification": {
      "call_to": "Llamando a",
      "incoming_call": "Llamada entrante",
      "tab_focus": "Enfocar pestaña activa del Webphone",
      "tab_focus_desc": "Haz clic en la notificación para abrir el Webphone"
    },
    "multipleTabsTitle": "¡No se permiten múltiples pestañas!",
    "multipleTabsDescription": "Parece que la aplicación ya está abierta en otra pestaña o ventana del navegador.",
    "focusActive": "Enfocar activo",
    "forceActive": "Forzar activación",
    "inbound_call": "Llamada entrante",
    "codecs": "Codecs",
    "codecsDescription": "Usa la casilla para activar/desactivar codecs. Arrastra para cambiar el orden de prioridad (mayor posición = mayor prioridad)",
    "codecName": "Nombre",
    "codecRate": "Tasa / Canales",
    "hertz": "Hz",
    "open_lead_at": "Abrir prospecto en",
    "caller_insights": "Información del llamante",
    "company": "Empresa",
    "last_modified": "Última modificación",
    "owner": "Propietario",
    "integration": "Integración",
    "installed_integration": "Integración instalada",
    "preferences": "Preferencias",
    "search_lead_number": "Buscar prospectos en llamadas",
    "no_integration": "Sin integración instalada",
    "search_lead_tooltip": "Buscar y mostrar información detallada del prospecto al hacer/recibir llamadas",
    "records_found": "Registros encontrados",
    "no_records_found": "No se encontraron registros",
    "create": "Crear",
    "search_kavkomcrm_only": "Buscar prospectos solo en Kavkom CRM",
    "search_kavkomcrm_tooltip": "Anula la búsqueda de prospectos en otras integraciones CRM instaladas",
    "kavkom_crm": "Kavkom CRM",
    "manage_conference": "Gestionar"
  }
  